// Lightweight Tome (novel) index.
//
// IMPORTANT:
// - Keep this file metadata-only.
// - Chapter prose lives in `public/chapters/*.md` and is fetched at runtime.

const novelData = [
  { id: 1, title: "A Shadow's Prey", path: '/chapters/chapter1.md' },
  { id: 2, title: 'A Mask for the Gutterborne', path: '/chapters/chapter2.md' },
  { id: 3, title: 'Ancestral Bonds', path: '/chapters/chapter3.md' },
  { id: 4, title: 'A Melody of Blood', path: '/chapters/chapter4.md' },
];

export default novelData;

